import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormBaseComponent } from '@platform/components/forms/form-base/form-base.component';
import { provideParentFormGroup } from '@platform/components/forms/forms.utils';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@Component({
  selector: 'app-form-toggle-user-language',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, MatInputModule, MatButtonModule, MatButtonToggleModule],
  templateUrl: './form-toggle-user-language.component.html',
  styleUrls: ['./form-toggle-user-language.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideParentFormGroup()],
})
export class FormToggleUserLanguageComponent extends FormBaseComponent {}
